module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_co_cats_wine_63db0765e253da42215b47fd085bd276.png";